export default function list_work() {
  // const slider = document.querySelector('.list.slider');

  // if (!slider) return;

  // const prevButton = slider.querySelector('.prev');
  // const nextButton = slider.querySelector('.next');
  // const sliderItems = slider.querySelectorAll('.list_row');

  // let currentIndex = 0;

  // function updateActive() {
  //   sliderItems.forEach((item, index) => {
  //     item.classList.toggle('active', index === currentIndex);
  //   });
  // }

  // updateActive();

  // nextButton?.addEventListener('click', () => {
  //   currentIndex = (currentIndex + 1) % sliderItems.length; // циклічний перехід
  //   updateActive();
  // });

  // prevButton?.addEventListener('click', () => {
  //   currentIndex = (currentIndex - 1 + sliderItems.length) % sliderItems.length; // циклічний перехід
  //   updateActive();
  // });

  const slider = document.querySelector("#listWorkSlider .list_slider");

  if (!slider) return;

  const prevButton = document.querySelector('#listWorkSlider .prev');
  const nextButton = document.querySelector('#listWorkSlider .next');

  const sliderItems = slider.querySelectorAll(".list_row");
  const totalItems = sliderItems.length;

  let visibleItems = 1;
  let currentIndex = 0;
  let maxIndex = totalItems - visibleItems;
  console.log('maxIndex', maxIndex)
  let gap = 0;
  let isEnabled = true;

  // swipe variables
  let startX = 0;
  let currentX = 0;
  let isDragging = false;

  currentIndexCheck();
  updateVisibleItems();
  window.addEventListener('resize', updateVisibleItems);

  prevButton.addEventListener("click", () => {
    if (!isEnabled) return;

    if (currentIndex > 0) {
      currentIndex--;
      updateSliderPosition();
      currentIndexCheck();
    }
  });

  nextButton.addEventListener("click", () => {
    if (!isEnabled) return;

    if (currentIndex < maxIndex) {

      currentIndex++;
      updateSliderPosition();
      currentIndexCheck();
    }
  });

  // swiping
  slider.addEventListener("touchstart", (e) => {
    if (!isEnabled) return;

    startX = e.touches[0].clientX;
    isDragging = true;
    slider.style.transition = "none";
  });

  slider.addEventListener("touchmove", (e) => {
    if (!isEnabled || !isDragging) return;

    currentX = e.touches[0].clientX;
    const deltaX = startX - currentX;
    const offset = currentIndex * (sliderItems[0].offsetWidth + gap) + deltaX;

    slider.style.transform = `translateX(-${offset}px)`;
  });

  slider.addEventListener("touchend", () => {
    if (!isEnabled || !isDragging) return;

    isDragging = false;
    slider.style.transition = "transform 0.5s ease";

    const deltaX = startX - currentX;

    if (deltaX > 50 && currentIndex < maxIndex) {
      currentIndex++;
    } else if (deltaX < -50 && currentIndex > 0) {
      currentIndex--;
    }

    currentIndexCheck();
    updateSliderPosition();
  });

  function updateSliderPosition() {
    const offset = currentIndex * (sliderItems[0].offsetWidth + gap);
    slider.style.transform = `translateX(-${offset}px)`;
  }

  function currentIndexCheck() {
    console.log('isEnabled: ', isEnabled )
    console.log('maxIndex: ', maxIndex )
    console.log('currentIndex: ', currentIndex )

    if (!isEnabled) {
      prevButton.setAttribute('disabled', true);
      nextButton.setAttribute('disabled', true);
      return;
    }

    if (currentIndex <= 0) {
      prevButton.setAttribute('disabled', true);
    } else {
      prevButton.removeAttribute('disabled');
    }

    if (currentIndex >= maxIndex) {
      console.log(1)
      nextButton.setAttribute('disabled', true);
    } else {
      nextButton.removeAttribute('disabled');
    }
  }

  function updateVisibleItems() {
    if (window.innerWidth < 361) {
      isEnabled = false;
      slider.style.transform = "none";
      currentIndex = 0;
      prevButton.setAttribute('disabled', true);
      nextButton.setAttribute('disabled', true);
      return;
    }

    isEnabled = true;

    if (window.innerWidth > 480 && window.innerWidth < 769) {
      visibleItems = 1;
      gap = 12;
    } else if (window.innerWidth < 481) {
      visibleItems = 1;
      gap = 12;
    } else {
      visibleItems = 1;
      gap = 0;
    }

    maxIndex = totalItems - visibleItems;

    if (currentIndex > maxIndex) {
      currentIndex = maxIndex;
    }

    currentIndexCheck();
    updateSliderPosition();
  }

}
